module.exports = __webpack_public_path__ + "manual-newNote.png?3c688aa136ef423a7a63bd140783cac1";


//////////////////
// WEBPACK FOOTER
// ./src/images/manual-newNote.png
// module id = 407
// module chunks = 0